import { SportType } from './sport-type.model';
import { SkillLevel } from './skill-level.model';
import { LessonType } from './lesson-type.model';
import { User } from './user.model';
import { ReservationStatus } from './reservation-status.model';
import { Grouptype } from './grouptype';

export class Reservation {
    id: number;
    dateFrom: string;
    dateTo: string;
    reservationSubItems: ReservationSubItem[];
    reservationItems: ReservationItem[];
/*     orderItems: OrderItem[]; */
    status: ReservationStatus;
    dateCreated: string;
    isCreatedByAdmin: boolean;
    user: User;
    numberOfDays: number;
    amount: number;
    amountPayed: number;
    paymentId: string;
    partialPaymentAllowed: boolean;
    partialPayment: boolean;
    isLessonReservation :number;
    constructor() {
        this.reservationSubItems = [];
        this.reservationItems = [];
    }
}

export class ReservationSubItem {
    public LessonId: number;
    public id: number;
    constructor(
      public name: string,
      public lastName: string,
      public age: number,
      public sportType: SportType,
      public skillLevel: SkillLevel,
      public note: string,
      public lessonType: LessonType,
      public isWithMeal: boolean,
      public isWithGear: boolean,
      public numberOfClassesIndivid: number,
      public groupType : Grouptype,
      public numberOfDays: number,
      public equipment :string,
      public height :number,
      public weight : number,
      public place : string
    ) {}
}

export class ReservationItem {
    productCode: string;
    productName: string;
    quantity: number;
    price: number;
    amount: number;
    productDescriptionSR: string;
    productDescriptionEN: string;
}

/* export class OrderItem {
  lessonType: number;
  isWithGear: number;
  isWithMeal: number;
  numberOfClassesIndivid: number;
  numberOfPersons: number;
  numberOfDays: number;
  productCode: string;
  productName: string;
  productDescription: string;
  descriptionSR: string;
  descriptionEN: string;
  quantity: number;
  amount: number;
  price: number;
} */
